/* eslint-disable @nx/enforce-module-boundaries */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Button,
  Card,
  Checkbox,
  CheckboxGroup,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Heading,
  Spinner,
  Stack,
  Switch,
  FormErrorMessage,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CityStateCountryDropdown } from 'v4/components/city-state-country-dropdown';
import { IndustryDropdown } from 'v4/components/industry-dropdown';
import { JobTitlesDropdown } from 'v4/components/job-titles-tag-input';
import { TagsInput } from 'v4/components/tags-input';
import { EMPLOYMENT_CHOICES } from 'v4/lib/data';
import { JobsListingContext } from '../context';
import { JobPreferencesResumeUploader } from '../resume-uploader';
import { formatCommaSeparated, formatLocation } from 'v4/lib/commons';
import { useToast } from '@mybridge/ui';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobalIndustriesDetail } from 'v4/store/actions/global.data.actions';
import { isMobile } from 'react-device-detect';
import _ from 'lodash';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
export const MyJobPreferences = forwardRef(({ ...props }, ref) => {
  const {
    jobPreferences,
    jobPreferencesLoading,
    jobPreferencesFetching,
    refetchJobPreferences,
    updateJobPreferencesLoading,
    updateJobPreferences,
  } = useContext(JobsListingContext);
  const { t } = useTranslator();
  const { loggedIn } = useSelector((state) => state?.user) ?? {};
  const {
    handleSubmit,
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      industries: jobPreferences?.industries ?? [],
      locations: jobPreferences?.locations ?? [],
      employment_type: jobPreferences?.employment_type ?? [],
      job_title: jobPreferences?.job_title ?? [],
    },
  });

  // useEffect(() => {
  //   refetchJobPreferences?.();
  // }, []);
  useEffect(() => {
    if (loggedIn) {
      refetchJobPreferences?.();
    }
  }, [loggedIn]);
  const [accIndex, setAccIndex] = useState(-1);
  const toast = useToast();
  const dispatch = useDispatch();
  const industries = [];
  const { job_availabilty = '0', job_alert = false } = jobPreferences ?? {};
  const { userProfileInfo } = useSelector((state) => state.userProfile);

  const onSubmit = (form) => {
    form.industries = form.industries?.map?.((v) => v.id);
    updateJobPreferences(
      { ...(form ?? {}), job_availabilty, job_alert },
      'json'
    ).then((response)=>{
      if (response) {
        trackEvent(ANALYTICS_EVENTS.JobPreferences, userProfileInfo?.slug)
      }
    })
  };

  const handleJobAvailbilty = () => {
    const newJobAvailability = job_availabilty
      ? job_availabilty === '0'
        ? '1'
        : '0'
      : '1';

    const payload = {
      job_availabilty: newJobAvailability,
      job_alert,
      industries: jobPreferences?.industries?.map?.((v) => v.id) ?? [],
      locations: jobPreferences?.locations ?? [],
      employment_type: jobPreferences?.employment_type ?? [],
      job_title: jobPreferences?.job_title ?? [],
    };

    // Open the "Preferences" tab when the option is enabled, collapse it when disabled
    if (newJobAvailability === '1') {
      setAccIndex(0); // Open the first accordion item (Preferences tab)
      toast({
        title: t('jobs.updatedSuccessfully') || 'Updated Successfully!',
        status: 'success',
        position: 'top',
        isClosable: true,
        duration: 3000,
      });
    } else {
      setAccIndex(-1); // Collapse the accordion
      toast({
        title: t('jobs.updatedSuccessfully') || 'Updated Successfully!',
        status: 'success',
        position: 'top',
        isClosable: true,
        duration: 3000,
      });
    }

    updateJobPreferences(payload, 'json', false);
  };

  const handleJobAlert = () => {
    if (
      (jobPreferences?.job_title?.length ||
        jobPreferences?.locations?.length ||
        jobPreferences?.industries?.length) &&
      !job_alert
    ) {
      const payload = {
        job_availabilty,
        job_alert: !job_alert,
        industries: jobPreferences?.industries?.map?.((v) => v.id) ?? [],
        locations: jobPreferences?.locations ?? [],
        employment_type: jobPreferences?.employment_type ?? [],
        job_title: jobPreferences?.job_title ?? [],
      };

      updateJobPreferences(payload, 'json', false);

      // Show success toaster after updating preferences
      toast({
        title: t('jobs.updatedSuccessfully') || 'Updated Successfully!',
        status: 'success',
        position: 'top',
        isClosable: true,
        duration: 3000,
      });
    } else if (job_alert) {
      const payload = {
        job_availabilty,
        job_alert: !job_alert,
        industries: jobPreferences?.industries?.map?.((v) => v.id) ?? [],
        locations: jobPreferences?.locations ?? [],
        employment_type: jobPreferences?.employment_type ?? [],
        job_title: jobPreferences?.job_title ?? [],
      };

      updateJobPreferences(payload, 'json', false);

      // Show success toaster after disabling job alert
      toast({
        title: t('jobs.updatedSuccessfully') || 'Updated Successfully!',
        status: 'success',
        position: 'top',
        isClosable: true,
        duration: 3000,
      });
    } else {
      // Show error toaster if no preferences are set
      toast({
        title: t('jobs.setJobPreferences') || `Set job preferences below to continue`,
        position: 'top',
        isClosable: true,
        status: 'error',
        duration: 9000,
      });
      setAccIndex(0); // Open the first accordion item (Preferences tab)
    }
  };

  // console.log('jobPreferences?.industries', jobPreferencesLoading,
  //   jobPreferencesFetching, jobPreferences);

  useEffect(() => {
    setValue('job_title', jobPreferences?.job_title);
    setValue('employment_type', jobPreferences?.employment_type);
    setValue('industries', jobPreferences?.industries);
    setValue('locations', jobPreferences?.locations);
  }, [jobPreferences]);

  return (
    <Stack w="100%">
      <Heading
        size="sm"
        my={[1, 6]}
        px={[2, 4]}
        fontWeight={['600', '400']}
        color="brandPrimary.500"
      >
        {t('jobs.preferences') || "Preferences"}
      </Heading>
      <Card
        p={['2%', 4]}
        mb={6}
        borderRadius={['8px', '8px']}
        boxShadow="none"
        border={['1px solid #D9D9D9', 'none']}
      >
        <Stack spacing={6}>
          <FormControl>
            <HStack alignItems="flex-start">
              <FormLabel fontWeight="700" flex={1} color="#747474">
                {t('jobs.recruiterStatus') || "Let recruiters know your status"}
              </FormLabel>
              <Switch
                // isDisabled={updateJobPreferencesLoading}
                onChange={handleJobAvailbilty}
                isChecked={job_availabilty === '1'}
              />
            </HStack>
            <FormHelperText>
              {t('jobs.openToOpportunities') || "Share that you're open to new opportunities and let your next job find you."}
            </FormHelperText>
          </FormControl>
          {!isMobile && <Divider orientation="horizontal"/>}
          <FormControl>
            <HStack alignItems="flex-start">
              <FormLabel fontWeight="700" flex={1} color="#747474">
                {t('jobs.jobAlert') || "Job alert"}
              </FormLabel>
              <Switch
                // isDisabled={updateJobPreferencesLoading}
                onChange={handleJobAlert}
                isChecked={job_alert}
              />
            </HStack>
            <FormHelperText>
              {t('jobs.jobAlertInfo') || "You'll receive notifications when new jobs are posted that match your search preferences."}
            </FormHelperText>
          </FormControl>
        </Stack>

        <Stack pt={6}>
          <Accordion
            border={['1px solid #D9D9D9', 'none']}
            borderRadius={['10px', '0px']}
            index={accIndex}
            px={0}
          >
            <AccordionItem
              p={['4px', '0px']}
              borderTopWidth="none"
              sx={{
                '&.chakra-accordion__item': {
                  borderBottomWidth: '0 !important', // Remove bottom border using !important
                },
              }}
            >
              <FormControl>
                <AccordionButton
                  _hover={{ bg: 'transparent' }}
                  onClick={(e) =>
                    accIndex === 0 ? setAccIndex(-1) : setAccIndex(0)
                  }
                  px={0}
                  as={Stack}
                  cursor="pointer"
                  spacing={0}
                  alignItems="stretch"
                  justifyContent="stretch"
                >
                  <HStack>
                    <Heading
                      flex={1}
                      size="sm"
                      fontWeight="700"
                      color="#747474"
                    >
                      {t('jobs.preferences') || "Preferences"}
                    </Heading>
                    {!isMobile ? (
                      <>
                        {accIndex === 0 ? (
                          <img src="/upArrow.png" alt="Up Arrow" />
                        ) : (
                          <img src="/downArrow.png" alt="Down Arrow" />
                        )}
                      </>
                    ) : (
                      <AccordionIcon />
                    )}
                  </HStack>
                  <FormHelperText>
                    {t('jobs.setPreferencesInfo') || "Set your preference and we will work on finding you more Job suggestions"}
                  </FormHelperText>
                </AccordionButton>
              </FormControl>
              <AccordionPanel px={0}>
                {jobPreferencesLoading || jobPreferencesFetching ? (
                  <Spinner />
                ) : (
                  <>
                    {jobPreferences?.id && (
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Stack spacing={6}>
                          <FormControl isInvalid={errors?.job_title}>
                            <FormLabel pb={2} fontWeight="700" color="#747474">
                              {t('jobs.jobTitle') || "Job Title"}
                            </FormLabel>
                            <Controller
                              render={({ field }) => (
                                // <JobTitlesTaggedInput keyName="id" {...field}
                                // />
                                <TagsInput title={t('profileMilestones.title') || "Title"} {...field}>
                                  {({ addTag, setEdit }) => (
                                    <JobTitlesDropdown
                                      clearOnSelect
                                      onEscape={(e) => setEdit(false)}
                                      borderRadius="full"
                                      inputGroupProps={{ maxW: '300px' }}
                                      keyName="title"
                                      field="title"
                                      onChange={(val) => {
                                        addTag(val);
                                        setEdit(false);
                                      }}
                                      autoFocus
                                    />
                                  )}
                                </TagsInput>
                              )}
                              name="job_title"
                              control={control}
                              // value={jobPreferences?.job_title}
                              rules={{
                                required: false,
                              }}
                            />
                            {errors?.job_title && (
                              <FormErrorMessage>
                                {t('jobs.jobTitleRequired') || "Job title is required"}
                              </FormErrorMessage>
                            )}
                          </FormControl>

                          <FormControl>
                            <FormLabel pb={2} fontWeight="700" color="#747474">
                              {t('jobs.employmentType') || "Employment Type"}
                            </FormLabel>
                            <Controller
                              render={({ field }) => (
                                <CheckboxGroup gap={6} {...field}>
                                  {EMPLOYMENT_CHOICES?.map((ec, ecIndex) => (
                                    <Checkbox
                                      mr={4}
                                      key={ecIndex}
                                      value={ec?.value}
                                    >
                                      {t(ec.translationKey) || ec.label}
                                    </Checkbox>
                                  ))}
                                </CheckboxGroup>
                              )}
                              name={'employment_type'}
                              control={control}
                            />
                          </FormControl>

                          <FormControl isInvalid={errors?.industries}>
                            <FormLabel pb={2} fontWeight="700" color="#747474">
                              {t('profileExperience.industry') || "Industry"}
                            </FormLabel>
                            <Controller
                              render={({ field }) => (
                                <TagsInput
                                  title={t('profileExperience.industry') || "Industry"}
                                  renderFn={(v) => v.name}
                                  {...field}
                                >
                                  {({ addTag, setEdit }) => (
                                    <IndustryDropdown
                                      clearOnSelect
                                      onEscape={(e) => setEdit(false)}
                                      borderRadius="full"
                                      inputGroupProps={{ maxW: '300px' }}
                                      onChange={(val) => {
                                        addTag(val);
                                        setEdit(false);
                                      }}
                                      autoFocus
                                    />
                                  )}
                                </TagsInput>
                                // <IndustryTagsInput keyName="id" {...field} />
                              )}
                              control={control}
                              name="industries"
                              rules={{
                                required: false,
                              }}
                            />
                            {errors?.industries && (
                              <FormErrorMessage>
                                {t('jobs.jobIndustryRequired') || "Job industry is required"}
                              </FormErrorMessage>
                            )}
                          </FormControl>

                          <FormControl isInvalid={errors?.locations}>
                            <FormLabel pb={2} fontWeight="700" color="#747474">
                              {t('myEvents.location') || "Location"}
                            </FormLabel>
                            <Controller
                              render={({ field }) => (
                                <TagsInput
                                  title={t('myEvents.location') || "Location"}
                                  renderFn={(v) => formatLocation(v)}
                                  {...field}
                                >
                                  {({ addTag, setEdit }) => (
                                    <CityStateCountryDropdown
                                      clearOnSelect
                                      onEscape={(e) => setEdit(false)}
                                      borderRadius="full"
                                      inputGroupProps={{ maxW: '300px' }}
                                      keyName="title"
                                      field="title"
                                      onChange={(val) => {
                                        addTag(val);
                                        setEdit(false);
                                      }}
                                      autoFocus
                                    />
                                  )}
                                </TagsInput>
                                // <LocationTagsInput
                                //   clearOnSelect={true}
                                //   keyName="id"
                                //   {...field}
                                // />
                              )}
                              rules={{
                                required: false,
                              }}
                              control={control}
                              name="locations"
                            />
                            {errors?.locations && (
                              <FormErrorMessage>
                                {t('jobs.jobLocationRequired') || "Job location is required"}
                              </FormErrorMessage>
                            )}
                          </FormControl>

                          <Stack>
                            <FormLabel fontWeight="700" color="#747474">
                              {t('jobs.resume') || "Resume"}
                            </FormLabel>
                            <JobPreferencesResumeUploader
                              isIndividual={false}
                            />
                          </Stack>
                        </Stack>

                        <HStack justifyContent="flex-end">
                          <Button
                            onClick={(e) => setAccIndex(-1)}
                            variant="secondary"
                            borderRadius="full"
                          >
                            {t('buttons.cancel') || "Cancel"}
                          </Button>
                          <Button
                            type="submit"
                            onClick={handleSubmit(onSubmit)}
                            variant="primary"
                            borderRadius="full"
                            isLoading={updateJobPreferencesLoading}
                          >
                            {t('buttons.save') || "Save"}
                          </Button>
                        </HStack>
                      </form>
                    )}
                  </>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Stack>
      </Card>
    </Stack>
  );
});
